import { render, staticRenderFns } from "./SubItemList.vue?vue&type=template&id=730ae768&scoped=true"
import script from "./SubItemList.vue?vue&type=script&lang=js"
export * from "./SubItemList.vue?vue&type=script&lang=js"
import style0 from "./SubItemList.vue?vue&type=style&index=0&id=730ae768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730ae768",
  null
  
)

export default component.exports